// The dashboard's information architecture, in one place. The header nav and
// each section's sub-navigation read from here so labels never drift.
//
//   Desk     — one page, no sub-navigation             (the owners' week: numbers, letter, lessons, changes)
//   Videos   — Library · Create · Pipeline            (the app's Videos tab)
//   Photos   — Looks · Stickers · Limits               (the app's Photos tab; WhatsApp sticker packs)
//   Runs     — one page and a page per run              (the reel workbench: quotes, approval, steps, outputs)
//   Quality  — Label · Overview                        (grading calibration, both tabs)
//   Settings — Budget · App · Users

import {
  Camera,
  Clapperboard,
  LayoutDashboard,
  Settings as SettingsIcon,
  ShieldCheck,
  Workflow,
  type LucideIcon,
} from '@/components/Icon';

export interface NavItem {
  to: string;
  label: string;
}

export interface Section extends NavItem {
  icon: LucideIcon;
  children: readonly NavItem[];
}

export const SECTIONS: readonly Section[] = [
  {
    to: '/desk',
    label: 'Desk',
    icon: LayoutDashboard,
    children: [],
  },
  {
    to: '/videos',
    label: 'Videos',
    icon: Clapperboard,
    children: [
      { to: '/videos/library', label: 'Library' },
      { to: '/videos/create', label: 'Create' },
      { to: '/videos/pipeline', label: 'Pipeline' },
    ],
  },
  {
    to: '/photos',
    label: 'Photos',
    icon: Camera,
    children: [
      { to: '/photos/looks', label: 'Looks' },
      { to: '/photos/stickers', label: 'Stickers' },
      { to: '/photos/limits', label: 'Limits' },
    ],
  },
  {
    to: '/runs',
    label: 'Runs',
    icon: Workflow,
    children: [],
  },
  {
    to: '/quality',
    label: 'Quality',
    icon: ShieldCheck,
    children: [
      { to: '/quality/label', label: 'Label' },
      { to: '/quality/overview', label: 'Overview' },
    ],
  },
  {
    to: '/settings',
    label: 'Settings',
    icon: SettingsIcon,
    children: [
      { to: '/settings/budget', label: 'Budget' },
      { to: '/settings/app', label: 'App' },
      { to: '/settings/users', label: 'Users' },
    ],
  },
];
